// Do not record OTPs, personal links or broker content in network replays.
// Other app endpoints retain the existing request-body capture behaviour.
export const workspacePrivateEndpoints = [
  /\/api\/hazel\/renewals\/drafts(?:\/|[?#]|$)/,
  /\/api\/reports(?:\/|[?#]|$)/,
  /\/api\/broker-workspace(?:\/|[?#]|$)/,
  // The public signing page's calls: the reference is the credential.
  /\/api\/signing(?:\/|[?#]|$)/,
  /\/api\/pm\/brokers\/[^/?#]+\/(?:issue|revoke)(?:[/?#]|$)/,
];
